import React from 'react'
import { useLocation } from '@reach/router'

// Bootstrap
// https://react-bootstrap.github.io/
// 必要な CSS は gatsby-browser.js で読み込む
import * as Bootstrap from 'react-bootstrap'
// Swiper
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper'

const expandWithPrefix = (prefix, object) =>
  Object.keys(object).reduce((acc, key) => {
    acc[`${prefix}${key}`] = object[key]
    return acc
  }, {})

// カスタムモジュール定義
const customModules = {
  // Bootstrap
  ...expandWithPrefix('Bootstrap', Bootstrap),
  // Bootstrap Tabs を拡張して hash を activeKey に指定できるようにする
  BootstrapTabs: (props) => {
    const { hash } = useLocation()
    const { defaultActiveKey } = props
    const [activeKey, setActiveKey] = React.useState(defaultActiveKey)
    React.useEffect(() => {
      const activeKeyPrefix = '#active-key-'
      const isHashActiveKey = hash.startsWith(activeKeyPrefix)
      if (isHashActiveKey) {
        const nextActiveKey = hash.replace(activeKeyPrefix, '')
        setActiveKey(nextActiveKey)
      }
    }, [hash])

    return (
      <Bootstrap.Tabs
        {...props}
        activeKey={activeKey}
        onSelect={(k) => setActiveKey(k)}
      />
    )
  },
  // Swiper
  Swiper: (props) => {
    const coreModules = []
    if ('autoplay' in props) {
      coreModules.push(Autoplay)
    }
    if ('pagination' in props) {
      coreModules.push(Pagination)
    }
    if ('navigation' in props) {
      coreModules.push(Navigation)
    }
    if (props?.effect === 'fade') {
      coreModules.push(EffectFade)
    }

    return <Swiper modules={coreModules} {...props} />
  },
  SwiperSlide,
}

export { customModules }
